import { render, staticRenderFns } from "./RedeemRecord.vue?vue&type=template&id=e73ed3d2&"
import script from "./RedeemRecord.vue?vue&type=script&lang=js&"
export * from "./RedeemRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports